import React from "react";
import styled from "styled-components";
import Search from "../../assets/img/search.png";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  -webkit-box-shadow: 0px 0px 17px -11px rgba(0, 0, 0, 0.58);
  box-shadow: 0px 0px 17px -11px rgba(0, 0, 0, 0.58);
  width: 100px;
  padding: 20px;
  align-items: center;
  @media only screen and (max-width: 480px) {
    width: 70px;
  }
`;

const Image = styled.img`
  width: 20px;
`;
const Description = styled.div`
  margin-top: 10px;
  text-align: center;
`;

const MiniCard = ({ desc }) => {
  return (
    <Container>
      <Image src={Search} />
      <Description>{desc}</Description>
    </Container>
  );
};

export default MiniCard;
